import { DataKeyValueAnyInterface } from '../../module/data/key-value/any.interface';

/**
 * Merge recursively objects into the target, javascript way.
 * You can merge any structure into another structure, there is no restriction.
 *
 * Ex: objectMerge(obj1, obj2, obj3)
 * - will merge obj2 into obj1
 * - will merge obj3 into obj1
 */
export function objectMerge(...args: DataKeyValueAnyInterface[]): DataKeyValueAnyInterface {
  const iMax = args.length;

  // For each argument starting from the 2nd one
  for (let i = 1; i < iMax; i++) {
    // Merge i object into 1st one
    Object.keys(args[i]).forEach((key) => {
      // Require recursive merge if both keys exist and are objects
      const origin = args[0][key];
      const merge = args[i][key];
      const recursive = origin === Object(origin) && merge === Object(merge);

      // Recursive merge or override the original value
      args[0][key] = recursive ? objectMerge(origin, merge) : merge;
    });
  }

  return args[0];
}
